import React, { useEffect, useMemo, useRef } from 'react';
import { api, apis, apiHolder } from 'api';
import useMailStore from '@web-mail/hooks/useMailStoreRedux';
import { LIST_MODEL } from '@web-mail/common/constant';
import { useState2SubordinateSlice } from '@web-mail/hooks/useState2SliceRedux';
import { useCanUpdate } from '@web-mail/hooks/useCanUpdate';
import { tabId } from '@web-common/state/reducer/mailTabReducer';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { actions as mailTabActions } from '@web-common/state/reducer/mailTabReducer';
import { getModuleAccessSelector } from '@web-common/state/reducer/privilegeReducer';
import useStateRef from '@web-mail/hooks/useStateRef';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
const loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
const trackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const systemApi = apiHolder.api.getSystemApi();
const SubordinateUIEventHandler = props => {
    const { sliceId } = props;
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const dispatch = useAppDispatch();
    const canUpdateRef = useCanUpdate(sliceId);
    const [mailDataList] = useMailStore('mailDataList', undefined, sliceId, 'subordinate');
    const curActiveKey = useAppSelector(state => state.globalReducer.activeKey);
    const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
    const [selectedFolder] = useState2SubordinateSlice('selectedFolder', undefined, sliceId);
    const [activeIds, setActiveIds] = useState2SubordinateSlice('activeIds', undefined, sliceId);
    const [selected] = useState2SubordinateSlice('mailListStateTab', undefined, sliceId);
    const [, setListModel] = useState2SubordinateSlice('defaultMailListSelectedModel', undefined, sliceId);
    const [subordinateList] = useState2SubordinateSlice('subordinateList', undefined, sliceId);
    const [hasCloseSubordinateMock] = useState2SubordinateSlice('hasCloseSubordinateMock', undefined, sliceId);
    const [mailSearchState] = useState2SubordinateSlice('mailSearchState');
    const isSearching = useMemo(() => !!mailSearchState, [mailSearchState]);
    const isSdTab = useMemo(() => currentTabId === tabId.subordinate, [currentTabId]);
    const subordinateInited = useRef(false);
    const showSdTab = useAppSelector(state => getModuleAccessSelector(state.privilegeReducer, 'COLLEAGUE_EMAIL', 'VIEW'));
    useEffect(() => {
        if (process.env.BUILD_ISEDM) {
            dispatch(mailTabActions.configSdTab(showSdTab));
            trackApi.track('show_subordinate_mail_tab', { showSdTab });
        }
    }, [showSdTab]);
    useEffect(() => {
        var _a;
        const visibleSdTab = subordinateList.length > 0;
        if (process.env.BUILD_ISLINGXI && !((_a = systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion)) {
            if (!visibleSdTab && !hasCloseSubordinateMock) {
                dispatch(Thunks.loadFolderData_sd_mock({
                    show: true,
                    sliceId,
                }));
            }
            else {
                dispatch(mailTabActions.configSdTab(visibleSdTab));
                trackApi.track('show_subordinate_mail_tab', { showSdTab: visibleSdTab });
                accountApi.doGetAccountIsAdmin().then(isAdmin => {
                    const AccountType = isAdmin ? '管理员' : '成员';
                    trackApi.track('pcmail_subordinate_show', { AccountType });
                });
            }
        }
        else if (navigateVersion) {
            dispatch(mailTabActions.configSdTab(visibleSdTab));
        }
    }, [subordinateList.length, navigateVersion]);
    useEffect(() => {
        if (process.env.BUILD_ISLINGXI) {
            dispatch(Thunks.loadFolderData_sd({
                noCache: true,
                showLoading: false,
                sliceId,
            }));
        }
    }, []);
    const isSdTabRef = useStateRef(isSdTab);
    const subordinateListRef = useStateRef(subordinateList);
    const sliceIdRef = useStateRef(sliceId);
    useEffect(() => {
        setTimeout(() => {
            try {
                if (location === null || location === void 0 ? void 0 : location.hash.includes('#mailbox')) {
                    const search = new URLSearchParams(location.hash.split('?')[1]);
                    const type = search.get('m');
                    if (type == 'subordinate_mail') {
                        if (isSdTabRef.current && subordinateListRef.current && subordinateListRef.current.length === 0) {
                            dispatch(Thunks.loadFolderData_sd({ sliceId: sliceIdRef.current }));
                        }
                    }
                }
            }
            catch (e) {
                console.log(e);
            }
        }, 10000);
    }, []);
    useEffect(() => {
        if (isSdTab && !subordinateInited.current) {
            subordinateInited.current = true;
            dispatch(Thunks.refreshPage_sd({ sliceId }));
        }
    }, [isSdTab]);
    useEffect(() => {
        if (canUpdateRef.current) {
            if (isSearching) {
            }
            else {
                const res = activeIds.filter(item => !!mailDataList.find(mail => mail.entry.id == item));
                if (res.length != activeIds.length) {
                    setActiveIds(res);
                }
            }
        }
    }, [mailDataList]);
    useEffect(() => {
        if (canUpdateRef.current) {
            setActiveIds([]);
            setListModel(LIST_MODEL.INIT);
        }
    }, [selectedFolder, selected]);
    return React.createElement(React.Fragment, null);
};
export default SubordinateUIEventHandler;
